import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase yapılandırma bilgileri
// Bu bilgileri Firebase Console'dan alabilirsiniz
const firebaseConfig = {
  apiKey: "AIzaSyAZl3k9P7fXhdn8DvpYtXNdbzfMN874aQ8",
  authDomain: "project-tracking-d8909.firebaseapp.com",
  projectId: "project-tracking-d8909",
  storageBucket: "project-tracking-d8909.firebasestorage.app",
  messagingSenderId: "1029717664095",
  appId: "1:1029717664095:web:88f50573aa29dbb35956ea"
};

// Firebase uygulamasını başlat
const app = initializeApp(firebaseConfig);

// Firestore veritabanını al
export const db = getFirestore(app);

export default app;
